'use client';
import BDButton from '@shared/components/elements/button';
import { InStockDiamond } from '@shared/lib/overnight/types';
import { renderMoney } from '@shared/lib/utils/money';
import Diamond360 from './diamond-360';

export default function DiamondListItem({
  diamond,
  button,
}: {
  diamond: InStockDiamond;
  button?: React.ReactNode;
}) {
  return (
    <div key={diamond.id} className="flex flex-col items-center gap-2">
      <Diamond360 diamond={diamond} />
      <h4 className="text-center text-sm font-normal">
        {diamond.carat} ct. {diamond.shape}{' '}
        {diamond.origin.toUpperCase().includes('LAB') ? 'Lab ' : 'Natural '}
        Diamond
      </h4>
      <p className="text-bd-dark/80 text-sm">
        {diamond.clarity} ・ {diamond.cut} ・ {diamond.color}
      </p>
      <p className="text-bd-dark/80 text-sm">{renderMoney(diamond.price)}</p>
      {button}
    </div>
  );
}

export function DiamondViewDetailButton({ diamondId }: { diamondId: string }) {
  return (
    <BDButton
      styleType="secondary"
      onClick={() => {
        window.location.href = `/shop/diamond/${diamondId}`;
      }}
      className="w-full py-2"
    >
      View Details
    </BDButton>
  );
}
